import React, { useState } from 'react'
import MultipleUpload from '../../../commons/Upload/MultipleUpload';
import { PaperClipIcon } from '../../../Icon';
import { UploadFileTypesPayload } from '../../../../commonTypes/fileManagerTypes';
import { LoginResponseType } from '../../../../redux/auth/authTypes';
import { SelctOptionType } from '../../../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm';

type AppProps={
    companyDetails:any;
    handleCompanyDetailsChange:(data:any)=>void;


}
const CompanyDetails = ({
    companyDetails,
    handleCompanyDetailsChange,

}:AppProps) => {
  const [accessToOthersText, setAccessToOthersText] = useState<string>("");
;
    return (
        <>
            <p style={{marginTop:"12px", fontWeight:"500"}}>COMPANY DETAILS</p>
            <div className='row'>
                <div className='col-md-3'>
                    <label htmlFor='Company Name'>Company Name</label>
                    <div  >
                        <input
                            type='text'
                            name='companyName'
                            className='form-control'
                            value={companyDetails?.companyName}
                            onChange={handleCompanyDetailsChange}
                        />
                    </div>
                </div>
                <div className='col-md-3'>
                    <label htmlFor='Contact Person Name'>Contact Person Name</label>
                    <div  >
                        <input
                            type='text'
                            name='contactPersonName'
                            className='form-control'
                            value={companyDetails?.contactPersonName}
                            onChange={handleCompanyDetailsChange}
                        />
                    </div>
                </div>
                <div className='col-md-3'>
                    <label htmlFor='Contact Number'>Contact Number</label>
                    <div  >
                        <input
                            type='number'
                            name='contactNumber'
                            className='form-control'
                            value={companyDetails?.contactNumber}
                            onChange={handleCompanyDetailsChange}
                        />
                    </div>
                </div>
                <div className='col-md-3'>
                    <label htmlFor='Email ID'>Email ID</label>
                    <div  >
                        <input
                            type='text'
                            name='emailId'
                            className='form-control'
                            value={companyDetails?.emailId}
                            onChange={handleCompanyDetailsChange}
                        />
                    </div>
                </div>
                    </div>

        </>
    )
}

export default CompanyDetails